import React from 'react'

import LinkedinViewer from '../linkedinViewer'
import { Candidate } from '../../types'
import { getAge } from '../../utils'
import Feed from '../feeds/feed'

interface RowProps {
  header: React.ReactNode
  content: React.ReactNode
}

function Row({ header, content }: RowProps) {
  return (
    <tr>
      <th className="text-nowrap border border-dotted border-border-grey p-2 text-left">
        {header}
      </th>
      <td className="w-full border border-dotted border-border-grey border-l-transparent p-2">
        {content}
      </td>
    </tr>
  )
}

interface Props {
  selectedCandidate: Candidate
}

export default function CandidatePreview(props: Props) {
  const { selectedCandidate } = props

  return (
    <React.Fragment>
      <div className="min-w-[480px] grow overflow-y-auto border-slate-300 py-5 pl-5 pr-4 shadow-[inset_9px_0_8px_-10px_rgba(0,0,0,0.3)] [&::-webkit-scrollbar]:hidden">
        <h1 className="!mb-0">{selectedCandidate.name}</h1>

        <table className="mb-8 mt-6 w-full">
          <tbody>
            <Row header="E-mail" content={selectedCandidate.email} />
            <Row header="WhatsApp" content={selectedCandidate.whatsapp} />
            <Row header="Location" content={selectedCandidate.location} />
            <Row
              header="Years in the industry"
              content={
                typeof selectedCandidate.yearsInTheIndustry === 'number'
                  ? `${selectedCandidate.yearsInTheIndustry} ${selectedCandidate.yearsInTheIndustry === 1 ? 'year' : 'years'}`
                  : ''
              }
            />
            <Row
              header="Age"
              content={
                selectedCandidate.birthdate &&
                getAge(selectedCandidate.birthdate)
              }
            />
            <Row header="Summary" content={selectedCandidate.summary} />
            <Row header="Referral" content={selectedCandidate.referal} />
            <Row
              header="Intended Fee"
              content={
                selectedCandidate.salary ? `$${selectedCandidate.salary}` : ''
              }
            />
          </tbody>
        </table>

        <Feed
          relatedId={selectedCandidate._id}
          relatedCollection="candidates"
          showEditor={false}
          showFilter
          showTasks={false}
        />
      </div>

      <div className="w-[480px] shrink-0 overflow-y-auto bg-white [&::-webkit-scrollbar]:hidden">
        <LinkedinViewer url={selectedCandidate.linkedin} />
      </div>
    </React.Fragment>
  )
}
